const SEGMENTS = {
  ROOT: '/modules/search',
} as const

/** Content type for search results tabs */
export const SearchContentType = {
  All: 'all',
  Movies: 'movies',
  TvShows: 'shows',
  TvChannels: 'tv',
  Events: 'events',
} as const

export type SearchContentType =
  (typeof SearchContentType)[keyof typeof SearchContentType]

export interface ResultsWithQueryParams {
  query: string
  contentType?: string
  typeOfSearch?: string
}

export const SEARCH = {
  /** Hybrid search path (root) */
  ROOT: SEGMENTS.ROOT,

  /** Search results path with content type (e.g. /modules/search/all) */
  results: (contentType: string = SearchContentType.All) =>
    `${SEGMENTS.ROOT}/${contentType}`,

  /** Hybrid search path with query: /modules/search?q=... */
  hybridWithQuery: (query: string, typeOfSearch?: string) => {
    const params = new URLSearchParams()
    params.set('q', query)
    if (typeOfSearch) params.set('type', typeOfSearch)
    return `${SEGMENTS.ROOT}?${params}`
  },

  /** Results search path with query: /modules/search/all?q=... */
  resultsWithQuery: ({
    query,
    contentType = SearchContentType.All,
    typeOfSearch,
  }: ResultsWithQueryParams) => {
    const params = new URLSearchParams()
    params.set('q', query)
    if (typeOfSearch) params.set('type', typeOfSearch)
    return `${SEGMENTS.ROOT}/${contentType}?${params}`
  },

  segments: SEGMENTS,
} as const
